import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from 'src/app/dialog.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ActivatedRoute, Router } from '@angular/router';
import { slideToTop } from '../../router-animation/router-animation.component';
import { sessionStorage } from 'src/app/localstorage.service';


@Component({
  selector: 'app-secondary-order-add',
  templateUrl: './secondary-order-add.component.html',
  styleUrls: ['./secondary-order-add.component.scss']
})
export class SecondaryOrderAddComponent implements OnInit {
  loader: boolean = false;
  savingFlag: boolean = false;
  data: any = {}
  items: any = []
  dealerList: any = [];
  siteList: any = [];
  dr_id: any;
  colorList: any = []
  brandList: any = []
  product_data = []
  product_detail: any = {}
  dr_detail: any = {}
  condition: any = {}
  Dist_state = ''
  product_resp: boolean;
  setPrice: any;
  gst: any;
  add_list = []
  user_data: any = {};
  order_total: any = 0;
  order_discount: any = 0;
  total_qty: any = 0;
  netamount: any = 0;
  total_gst_amount: any = 0;
  order_grand_total: any = 0;
  sub_total: any = 0;
  dis_amt: any = 0;
  gst_amount: any = 0;
  net_total: any = 0;
  spcl_dis_amt: any = 0
  grand_total: any = 0;
  total_Order_amount: any = ''
  new_grand_total: any = 0;
  SpecialDiscountLable: any = ''
  contenteditable: boolean = true;
  editprice: boolean = true;
  nexturl: any;
  login_data: any = {};
  addToListButton: boolean = true;
  deactive: boolean = false;
  Distributor_list: any = []
  selectedBrand: any = '';
  warehouseList: any = [];
  thicknessList: any = [];
  sizeList: any = [];
  item: any = [];
  totalWeight: any = 0;
  tonWeight: any = 0
  routesValue: any = {};



  constructor(public serve: DatabaseService, public toast: ToastrManager, public route: ActivatedRoute, public dialog: DialogComponent, private router: Router, public session: sessionStorage,) {
    this.login_data = this.session.getSession();
    this.login_data = this.login_data.value;
    this.login_data = this.login_data.data;
    this.getBrand('');
  }
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.routesValue = this.route.queryParams['_value'];
      // if (this.routesValue.pageType == 'LeadOrder') {
      //   this.data.dr_type = this.routesValue.influencer_type.toString();
      //   this.data.pageType = this.routesValue.pageType;
      //   this.data.dealer_name = this.routesValue.influencer.toString();
      //   this.data.site_id = this.routesValue.site.toString();
      //   this.data.assigned_to_user_id = this.routesValue.user_id.toString();
      //   this.getSiteList(this.data.site_id);
      //   this.distributors('');
      //   this.get_distributorList('');
      // }

      if (this.routesValue.orderType == 'Stock') {
        this.data.dr_type = '3'
        this.distributors('');
      }
    });
    if (this.routesValue.pageType == 'LeadOrder') {
      this.data.dr_type = '15'
      this.distributors(this.routesValue.mobileNo);
      this.data.dealer_name=this.routesValue.drId
      this.data.assigned_to_user_id = this.routesValue.user_id.toString();
      console.log( this.data.assigned_to_user_id,"user_id")
      this.get_distributorList('');
    }
  }

  distributors(masterSearch) {
    this.loader = true
    this.serve.post_rqst({ 'dr_type': this.data.dr_type, 'dr_id': '', 'master_search': masterSearch }, "Order/followupCustomer").subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.loader = false
        this.dealerList = resp['result'];
      } else {
        this.toast.errorToastr(resp['statusMsg'])
        this.loader = false
      }
    }, err => {
      this.loader = false;

    })
  }


  getSiteList(id) {
    this.loader = true
    this.serve.post_rqst({ 'site_id': id }, "Order/getSiteList").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.loader = false
        this.siteList = result['site'];
      } else {
        this.toast.errorToastr(result['statusMsg'])
        this.loader = false
      }
    }, err => {
      this.loader = false;
 
    })
  }


  distributorDetail() {
    this.loader = true;
    this.dr_id = this.data.distributor_id;
    let id = { "id": this.dr_id };
    this.serve.post_rqst(id, "CustomerNetwork/distributorDetail").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.loader = false
        this.dr_detail = result['distributor_detail'];
        this.getItemList('')
      } else {
        this.loader = true
        this.toast.errorToastr(result['statusMsg'])
      }

    })
  }
  getAllDistributor() {

    this.loader = true;
    let id = { "id": this.dr_id }
    this.serve.post_rqst(id, "Order/getAllDistributor").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.loader = false
        this.dr_detail = result['distributor_detail'];
        this.getItemList('')
      } else {
        this.loader = true
        this.toast.errorToastr(result['statusMsg'])
      }

    })
  }

  get_dealerList() {
    this.loader = true

    this.serve.post_rqst({ 'dr_id': this.dr_id, 'dr_type': 3 }, "Order/assignedDealer").subscribe(resp => {
      if (resp['statusCode'] == 200) {
        this.loader = false
        this.dealerList = resp['result'];
      } else {
        this.toast.errorToastr(resp['statusMsg'])
        this.loader = false
      }
    })
  }

  get_distributorList(event: any = '') {
    this.loader = true;
    this.serve.post_rqst({ 'dealer_id': this.data.dealer_name, 'user_id': this.routesValue.pageType == 'LeadOrder' ? [this.data.assigned_to_user_id] : this.userId, 'master_search': event }, "Order/getAssignDistributor").subscribe(resp => {
      if (resp['statusCode'] == 200) {
        this.loader = false
        this.Distributor_list = resp['distributor_arr'];
      } else {
        this.toast.errorToastr(resp['statusMsg'])
        this.loader = false
      }
    })
  }

  userId: any = [];

  findUserId(id) {
    let Index = this.dealerList.findIndex(row => row.id == id)
    if (Index != -1) {
      this.userId = this.dealerList[Index]['assign_user']
    }
  }


  getItemList(search) {
    this.serve.post_rqst({ 'data': { 'dr_id': this.dr_id, 'order_type': 'secondary' }, 'filter': { 'search': search } }, "Order/segmentItems")
      .subscribe(resp => {
        if (resp['statusCode'] == 200) {
          this.loader = false
          let detail
          detail = resp['result'];
          this.product_detail.product_name = detail.product_name;
          this.product_detail.id = detail.id;
          this.product_detail.category_id = detail.category_id;
          this.product_detail.category = detail.category;
          this.product_detail.product_code = detail.product_code;
        } else {
          this.toast.errorToastr(resp['statusMsg'])
          this.loader = false
        }
      })

  }


  getdealerstate(id) {
    let Index = this.dealerList.findIndex(row => row.id == id);
    if (Index != -1) {
      this.Dist_state = this.dealerList[Index].state
    }
  }
  getitemdetail(id) {
    let Index = this.items.findIndex(row => row.id == id);
    if (Index != -1) {

      this.data.product_gst = this.items[Index].gst
    }
  }





  editDiscount() {
    this.contenteditable = false
  }
  editPrice() {
    this.editprice = false
    // this.data.product_price=''
  }






  // Order 
  getBrand(search) {
    this.serve.post_rqst({ 'search': search }, "Order/brandList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.brandList = result['result'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }

  getThickness() {
    this.product_detail.thickness = '';
    this.product_detail.size = '';
    this.serve.post_rqst({ 'brand': this.product_detail.brand }, "Order/productThikness").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.thicknessList = result['result'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }
  getSize() {
    this.product_detail.size = '';
    this.serve.post_rqst({ 'brand': this.product_detail.brand, 'thickness': this.product_detail.thickness }, "Order/productSize").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.sizeList = result['result'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }


  addToList() {
    if (!this.product_detail.brand) {
      this.toast.errorToastr("Please select brand")
      return
    }
    if (!this.product_detail.thickness) {
      this.toast.errorToastr("Please select thickness")
      return
    }
    if (!this.product_detail.size) {
      this.toast.errorToastr("Please select size")
      return
    }
    if (!this.product_detail.qty) {
      this.toast.errorToastr("Please enter qty.")
      return
    }
    if (!this.product_detail.product_type) {
      this.toast.errorToastr("Please enter qty.")
      return
    }
    if (this.product_detail.qty == '0') {
      this.toast.errorToastr("Please enter at least one qty.")
      return
    }

    if (this.item.length > 0) {
      let existIndex
      existIndex = this.item.findIndex(row => row.brand == this.product_detail.brand && row.thickness == this.product_detail.thickness && row.size == this.product_detail.size && row.product_type ==this.product_detail.product_type );
      if (existIndex != -1) {
        this.item[existIndex]['qty'] += parseFloat(this.product_detail.qty);
        this.blankValue();
      }
      else {
        this.item.push({ 'brand': this.product_detail.brand, 'segment_name': this.product_detail.category, 'segment_id': this.product_detail.category_id, 'product_name': this.product_detail.product_name, 'product_code': this.product_detail.product_code, 'thickness': this.product_detail.thickness, 'product_id': this.product_detail.id, 'size': this.product_detail.size, 'qty': parseFloat(this.product_detail.qty),'product_type':this.product_detail.product_type })
        this.blankValue();
      }
    }
    else {
      this.item.push({ 'brand': this.product_detail.brand, 'segment_name': this.product_detail.category, 'segment_id': this.product_detail.category_id, 'product_name': this.product_detail.product_name, 'product_code': this.product_detail.product_code, 'thickness': this.product_detail.thickness, 'product_id': this.product_detail.id, 'size': this.product_detail.size, 'qty': parseFloat(this.product_detail.qty),'product_type':this.product_detail.product_type })
      this.blankValue();
    }

    this.total_qty = 0;
    for (let i = 0; i < this.item.length; i++) {
      this.total_qty += parseInt(this.item[i]['qty']);
    }

  }





  blankValue() {
    this.product_detail.qty = '';
    this.product_detail.size = '';
    this.product_detail.thickness = '';
    this.product_detail.brand = '';
    this.product_detail.product_type='';
  }






  listdelete(i) {
    this.total_qty = 0;
    this.item.splice(i, 1);
    for (let i = 0; i < this.item.length; i++) {
      this.total_qty += parseInt(this.item[i]['qty']);
    }
  }

  // End


  save_orderalert() {
    this.dialog.confirm("You want to submit this order ?").then((result) => {
      if (result) {
        this.save_order()
      }
    })
  }

  save_order() {

    // if (!this.data.remark) {
    //   this.toast.errorToastr("Remark is required")
    //   return
    // }

    if (parseInt(this.product_detail.qty) <= 0) {
      this.toast.errorToastr("Please enter at least one qty.")
      return
    }

    this.user_data.dr_id = this.data.dealer_name
    this.user_data.distributor_id = this.dr_id;
    this.user_data.site_id = this.routesValue.pageType == 'LeadOrder' ? this.data.site_id : ''
    this.user_data.order_type = 'WEB ORDER';
    this.user_data.remark = this.data.remark;
    this.user_data.type = this.routesValue.orderType.toLowerCase();
    this.savingFlag = true;

    this.serve.post_rqst({ "cart_data": this.item, "user_data": this.user_data, }, "Order/secondaryOrdersAdd").subscribe(resp => {
      if (resp['statusCode'] == 200) {
        this.savingFlag = false;
        this.dialog.success('', resp['statusMsg']);
        if (this.routesValue.orderType == 'Order') {
          this.router.navigate(['/secondary-order-list'], { queryParams: { 'orderType': this.routesValue.orderType } });
        }
        else {
          this.router.navigate(['/secondary-order-list/stock-order'], { queryParams: { 'orderType': this.routesValue.orderType } });
        }

      } else {
        this.savingFlag = false;
        this.dialog.error(resp['statusMsg']);

      }
    },
      error => {

      })

  }
  back() {
    window.history.back();
  }
}

